import { LogInContainer } from '@/modules/Auth';

const SignIn = (): JSX.Element => <LogInContainer />;

export default SignIn;
